export const scrollToAnalysis = (userId) => {
  const myAnalysisHeader = document.getElementById(`userAnalysis-${userId}`);
  myAnalysisHeader.scrollIntoView(true, { behavior: 'smooth' });
  myAnalysisHeader.classList.remove('whiteBackground');
  myAnalysisHeader.classList.add('greyBackground');
  setTimeout(() => {
    myAnalysisHeader.classList.add('whiteBackground');
    myAnalysisHeader.classList.remove('greyBackground');
  });
};

export const scrollToAnalysisElement = (analysisElementId) => {
  const myAnalysisHeader = document.getElementById(`analysis-element-${analysisElementId}`);
  myAnalysisHeader.scrollIntoView(true, { behavior: 'smooth' });
  myAnalysisHeader.offsetParent.scrollTop -= 20;
  myAnalysisHeader.classList.add('blue-background');
  setTimeout(() => {
    myAnalysisHeader.classList.remove('blue-background');
  }, 500);
};
